export default "__VITE_ASSET__FhbHAIXU__"